module.exports = __webpack_public_path__ + "img/rocketi.19f2e4e0.png";